import { Component, OnInit, NgZone, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, merge, interval, Observable, Subscription } from 'rxjs'
import { switchMap, take, skipWhile } from 'rxjs/operators'
import {Amplify} from 'aws-amplify';
import { signInWithRedirect, signOut } from 'aws-amplify/auth';
import {environment} from '@environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    localStorage.setItem('unloadedTimestamp', new Date().toISOString());
    localStorage.setItem('continueLogout', "false");
    this.removeTabId()
  }

  //seconds
  inactivityTime: number = 900;

  timeLapsedSinceInactivity: number = 0;
  subscription: Subscription;
  observeable$: Observable<any>;
  mergedObservable$: Observable<any>;
  tabId: string = ""

  public inactivityTimerEvent: Array<any>[] = [
    [document, 'click'],
    [document, 'wheel'],
    [document, 'scroll'],
    [window, 'scroll'],
    [window, 'load'],
  ];


  constructor(public _ngZone: NgZone, private router: Router) {

  }

  async logoutChecker() {
    const unloadedTimestamp = localStorage.getItem('unloadedTimestamp');
    const secondsToWait = 10 // seconds to wait before logging out the user on unload

    const timeunloaded = new Date(unloadedTimestamp);
    const currentDate = new Date();

    const userEmail = localStorage.getItem('userEmail');

    var timeDifference = currentDate.getTime() - timeunloaded.getTime();
    var seconds = Math.floor(timeDifference / 1000);

    console.log('secondseee', {
      seconds,
      unloadedTimestamp,
      userEmail,
    });

    const continueLogout = localStorage.getItem('continueLogout');
    if (continueLogout == "false"){
      return false;
    }

    if (unloadedTimestamp && seconds > secondsToWait && userEmail) {
      await signOut();
      localStorage.clear();
    }
  }

  ngOnInit() {
    let observableArray$: Observable<any>[] = [];
    this.inactivityTimerEvent.forEach(x => {
      observableArray$.push(fromEvent(x[0], x[1]));
    });
    this.mergedObservable$ = merge(...observableArray$);
    this.createObservable();
    this.initTabIdPerTab()
    this.logOutUser()
    // this.logoutChecker();
  }

  createObservable(): void {
    this._ngZone.runOutsideAngular(() => {
      this.observeable$ = this.mergedObservable$.pipe(
        switchMap(ev => interval(1000).pipe(take(this.inactivityTime))),
        skipWhile(x => {
          this.timeLapsedSinceInactivity = x;
          return x != this.inactivityTime - 1;
        })
      );

      this.subscribeObservable();
    });
  }

  subscribeObservable() {
    this.subscription = this.observeable$.subscribe(x => {
      console.log(`idle for ${x + 1} sec`);
      this.unsubscribeObservable();
    });
  }

  async unsubscribeObservable() {
    await signOut();
    localStorage.clear();
    // window.location.replace(environment.signOut);
    this.subscription.unsubscribe();
  }

  initTabIdPerTab() {
    const existingTabId = sessionStorage.getItem('tabId')
    if (existingTabId) {
      this.tabId = existingTabId
    } else {
      this.tabId = `${Date.now()}${Math.random().toString(36).substring(2)}`
      sessionStorage.setItem('tabId', this.tabId)
    }
    this.addTabId()
  }

  addTabId() {
    const idList = this.getTabIdList()
    if (!idList.includes(this.tabId)) {
      idList.push(this.tabId)
      localStorage.setItem('tabIdList', JSON.stringify(idList))
    }
  }

  getTabIdList() {
    const tabaIdList  = localStorage.getItem('tabIdList') || '[]'
    const parsedList = JSON.parse(tabaIdList)
    return parsedList
  }

  async removeTabId() {
    const idList = this.getTabIdList()

    const filteredIdList = idList.filter((data) => data !== this.tabId)
    localStorage.setItem('tabIdList', JSON.stringify(filteredIdList))

    if (filteredIdList.length === 0) {
      localStorage.setItem('lastTabId', this.tabId);
    }
  }

 async logOutUser() {
  const tabIdList = this.getTabIdList()

  if (tabIdList.length > 1) return;

  const lastTabId = localStorage.getItem("lastTabId")

  if (lastTabId && (this.tabId !== lastTabId)) {
    await signOut()
    localStorage.clear()
   }
  }
}
